import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_4ced9567-878b-4197-bbc3-520d4526f79c/artifacts/lx2s7y4x_logo_s.png";

export const Footer = () => {
  return (
    <footer className="bg-[#0A0A0A] text-white" data-testid="footer">
      <div className="px-6 md:px-12 lg:px-24 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div className="lg:col-span-1">
            <img 
              src={LOGO_URL} 
              alt="SC SOLAR CONSTRUCT SRL" 
              className="h-14 mb-6 brightness-0 invert"
            />
            <p className="text-[#737373] text-sm leading-relaxed">
              Furnizor de încredere de beton de calitate superioară pentru proiectele dumneavoastră de construcții din regiunea Focșani.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xs font-bold tracking-[0.2em] uppercase mb-6 text-[#FACC15]">
              Navigare
            </h3>
            <nav className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-[#737373] hover:text-white transition-colors" data-testid="footer-link-home">
                Acasă
              </Link>
              <Link to="/despre" className="text-sm text-[#737373] hover:text-white transition-colors" data-testid="footer-link-despre">
                Despre Noi
              </Link>
              <Link to="/servicii" className="text-sm text-[#737373] hover:text-white transition-colors" data-testid="footer-link-servicii">
                Servicii
              </Link>
              <Link to="/galerie" className="text-sm text-[#737373] hover:text-white transition-colors" data-testid="footer-link-galerie">
                Galerie
              </Link>
              <Link to="/certificari" className="text-sm text-[#737373] hover:text-white transition-colors" data-testid="footer-link-certificari">
                Certificări
              </Link>
              <Link to="/contact" className="text-sm text-[#737373] hover:text-white transition-colors" data-testid="footer-link-contact">
                Contact
              </Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xs font-bold tracking-[0.2em] uppercase mb-6 text-[#FACC15]">
              Contact
            </h3>
            <div className="space-y-4">
              <a href="tel:+40722344534" className="flex items-start gap-3 text-[#737373] hover:text-white transition-colors" data-testid="footer-phone">
                <Phone className="w-4 h-4 mt-0.5 text-[#FACC15]" />
                <span className="text-2xl font-bold text-white">+40 722 344 534</span>
              </a>
              <a href="mailto:office@solar-beton.ro" className="flex items-start gap-3 text-[#737373] hover:text-white transition-colors" data-testid="footer-email">
                <Mail className="w-4 h-4 mt-0.5 text-[#FACC15]" />
                <span className="text-sm">office@solar-beton.ro</span>
              </a>
              <div className="flex items-start gap-3 text-[#737373]" data-testid="footer-address">
                <MapPin className="w-4 h-4 mt-0.5 text-[#FACC15]" />
                <span className="text-sm">Str. Vilcele Nr. 15 bis<br />Focșani, Vrancea, România</span>
              </div>
              <div className="flex items-start gap-3 text-[#737373]" data-testid="footer-hours">
                <Clock className="w-4 h-4 mt-0.5 text-[#FACC15]" />
                <span className="text-sm">Luni - Vineri<br />07:30 - 16:30</span>
              </div>
            </div>
          </div>

          {/* Map */}
          <div>
            <h3 className="text-xs font-bold tracking-[0.2em] uppercase mb-6 text-[#FACC15]">
              Locație
            </h3>
            <div className="aspect-video w-full">
              <iframe
                src="https://maps.google.com/maps?q=Strada+Vilcele+15+bis,+Focsani,+Vrancea,+Romania&t=&z=15&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="100%"
                style={{ border: 0, filter: "grayscale(100%)" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="SC SOLAR CONSTRUCT SRL Location"
                data-testid="footer-map"
              />
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#171717] mt-16 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#737373]">
            © {new Date().getFullYear()} SC SOLAR CONSTRUCT SRL. Toate drepturile rezervate.
          </p>
          <p className="text-xs text-[#737373]">
            CUI: RO14925112 | J39/415/2002
          </p>
        </div>

        {/* Powered By */}
        <div className="mt-8 flex justify-center">
          <a 
            href="https://cyberfolks.ro/clienti/aff.php?aff=563" 
            target="_blank" 
            rel="noopener noreferrer"
            className="opacity-80 hover:opacity-100 transition-opacity"
            data-testid="cyberfolks-link"
          >
            <img 
              src="https://customer-assets.emergentagent.com/job_sc-solar-ro/artifacts/phzo3mpm_Gemini_Generated_Image_ep800uep800uep80.png" 
              alt="Powered by cyber_Folks" 
              className="h-24 w-auto max-w-[280px]"
            />
          </a>
        </div>
      </div>
    </footer>
  );
};
